/* eslint-disable react-hooks/exhaustive-deps */
import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Alert, Box, Snackbar, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import Sidebar from './Sidebar';

import HeaderOnlineMediaClipping from './HeaderOnlineMediaClipping';

import HeaderCustomDashboard from './HeaderCustomDashboard';

import { useLocation, useNavigate } from 'react-router';
import {
  ONLINE_MEDIA_CLIPPING,
  SOCIAL_MEDIA_CAMPAIGN,
  STREAM_PANEL_ONLINE_MEDIA,
  STREAM_PANEL_SOCIAL_MEDIA,
  SETTINGS,
  ONLINE_MEDIA_STATISTIC,
  CUSTOM_DASHBOARD,
  ADD_AUTO_LABEL,
  SOCIAL_MEDIA_COMPARISON,
  SOCIAL_MEDIA_ADD_COMPARISON,
  ONLINE_MEDIA_COMPARISON,
  PEOPLE_PANEL,
  STREAM_PANEL_OFFLINE_MEDIA,
  OFFLINE_MEDIA_STATISTIC,
  CUSTOM_REPORT,
  ADD_AUTO_LABEL_ONM,
  SETTINGS_LABEL,
  OFFLINE_MEDIA_CLIPPING,
  OFFLINE_MEDIA_COMPARISON,
  CHAT_NOW_CHAT_HISTORY,
  CHAT_NOW_NEW_CHAT,
  CHAT_NOW_GUIDELINES,
  GOOGLE_REVIEW_COMPARISON,
  OVERVIEW,
  CUSTOM_REPORT_NEWSLATTER,
  ECOMMERCE_COMPARISON,
  ECOMMERCE_STREAM,
  VIDEO_TUTORIAL,
  ADD_AUTO_LABEL_ECOMMERCE,
  SETTINGS_OBJECT,
  SOCIAL_MEDIA_SNA,
  SOCIAL_MEDIA_CLUSTERING,
  SOCIAL_MEDIA_DNA
} from 'src/route';

import useQueryUrl from 'src/hooks/useQuery';

import HeaderPreferenceCampaign from './HeaderPreferenceCampaign';
import MinimalistHeader from './MinimalistHeader';

import HeaderComparisonDashboard from './HeaderComparisonDashboard';

import { useAlert } from 'src/hooks/useAlert';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { useTopNotification } from 'src/hooks/useTopNotification';
import TopNotification from '../components/TopNotification';
import HeaderPeoplePanel from './HeaderPeoplePanel';
import HeaderOfflineMedia from './HeaderOfflineMedia';
import HeaderOfflineMediaStatistic from './HeaderOfflineMediaStatistic';

import HeaderCustomReportById from './HeaderCustomReportById';

import HeaderOfflineMediaComparison from 'src/layouts/SidebarLayout/HeaderOfflineMediaComparison';
import HeaderChatNowNewChat from './HeaderChatNowNewChat';
import useGoogleReview from 'src/services/useGoogleReview';

import ModalProductTour from 'src/components/ModalProductTour';
import BlackScreenComponent from './BlackScreenComponent';
import ScrollRefProvider from './Sidebar/ScrollRefProvider';
import UnSupportPage from 'src/components/UnSupportPage';

import FloatingButtons from './components/FloatingButtons';
import HeaderEcommerceStream from './HeaderEcommerceStream';
import useEcommerce from 'src/services/useEcommerce';
import useBillingSystem from 'src/services/useBillingSystem';
import TopHeaderV2 from '../../components/Retail/TopV2';
import HeaderRetail from 'src/components/Retail/Headers/Header';
import HeaderOnlineMediaRetail from 'src/components/Retail/Headers/HeaderOnlineMedia';
import HeaderSocialMediaStreamRetail from 'src/components/Retail/Headers/HeaderSocialMediaStream';
import ChatNowRetail from 'src/components/Retail/ChatNowRetail';
import HeaderOnlineMediaStatisticRetail from 'src/components/Retail/Headers/HeaderOnlineMediaStatistic';
import HeaderOnlineMediaClippingByIdRetail from 'src/components/Retail/Headers/HeaderOnlineMediaClippingByIdRetail';
import HeaderSocialMediaHashtagRetail from 'src/components/Retail/Headers/HeaderSocialMediaHashtag';
import HeaderComparisonDashboardRetail from 'src/components/Retail/Headers/HeaderComparisonDashboard';
import HeaderComparisonOnmRetail from 'src/components/Retail/Headers/HeaderComparisonOnm';
import moment from 'moment';
import HeaderComparisonDashboardEcommerce from './HeaderComparisonDashboardEcommerce';
import HeaderOfflineMediaClippingByIdRetail from 'src/components/Retail/Headers/HeaderOfflineMediaClippingByIdRetail';
import { useWebSocket } from 'src/hooks/useWebSocket';
import { IObject } from 'src/models/objectManagement';
import { reducerUpdateObjectList } from 'src/features/objectManagement';
import { useApolloClient } from '@apollo/client';
import { GET_OBJECTS_WITH_STATUS } from 'src/services/graphql/objectManagement/query';

interface SidebarLayoutProps {
  children?: ReactNode;
}

interface MainBodyProps {
  isOnTour: boolean;
  isRetail?: boolean;
}

const MainWrapper = styled(Box)(
  ({ theme }) => `
    width: 100vw;
    height: 100%;
    position: relative;
    display: flex;
    flex: 1 1 0%;
    background: white;
    cursor: default
`
);

const MainContent = styled(Box)<{ isOnTour: boolean }>(
  ({ theme, isOnTour }) => `
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    ${isOnTour && 'min-height: 100vh;'}
`
);

const MainBody = styled(Box)<MainBodyProps>(
  ({ theme, isOnTour, isRetail = false }) => `
  flex-grow: 0;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  background: #F5F5F5;
  ${!isOnTour && 'z-index: 1;'}
  height: calc(100vh - 45px);
  max-height: 100%;
  position: relative;
  overflow: auto;
`
);

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();
  const { handleCloseAlert, handleClickAlert } = useAlert();
  const stateAlert = useAppSelector((state) => state.storeAlert.alert);
  const objectList = useAppSelector(
    (state) => state.objectManagement.objectList
  );
  const {
    status,
    isProviderLtd,
    subscriptionEndDate: endDateString,
    customerType,
    id: projectId,
    timezone
  } = useAppSelector((state) => state.users.project);
  // const { comparisonList } = useAppSelector((state) => state.storeComparison);
  const { useGetGoogleComparisonList } = useGoogleReview();
  const [getGoogleComparisonList, { data: googleComparisonList }] =
    useGetGoogleComparisonList();
  const { useGetEcommerceObjectList, useGetEcommerceLabel } = useEcommerce();
  const [getEcommerceObjectList] = useGetEcommerceObjectList();
  const [getEcommerceLabel] = useGetEcommerceLabel();
  const { isPictureInPictureMode } = useAppSelector((state) => state.chatNow);
  const { isOnTour, isTourButtonOpen } = useAppSelector(
    (state) => state.storeProductTour
  );
  const { isOpen: isAIAssistantOpen, position: positionAIAssistant } =
    useAppSelector((state) => state.storeAIAssistantPosition);

  const subscriptionEndDate = new Date(endDateString);
  const { pathname } = useLocation();
  const pathValue = pathname.split('/')[3];
  const pathValueSetting = pathname.split('/')[2];
  const pathValueComparison = pathname.split('/')[4];
  const query = useQueryUrl();
  const preferences = query.get('preferences');
  const history = query.get('history');
  const tabComparison = query.get('tab');
  const navigator = useNavigate();
  const theme = useTheme();
  const { handleShowTopNotification, handleCloseNotification } =
    useTopNotification();

  const getTopPadding = () => {
    switch (pathname) {
      // case STREAM_PANEL_SOCIAL_MEDIA:
      //   return 0;
      // case STREAM_PANEL_ONLINE_MEDIA:
      // return portalId ? 0 : 0;
      // case `${ONLINE_MEDIA_CLIPPING}/${pathValue}`:
      //   return 0;
      case ONLINE_MEDIA_CLIPPING:
        return 4;
      case OFFLINE_MEDIA_CLIPPING:
        return 4;
      case SOCIAL_MEDIA_CAMPAIGN:
        if (!preferences && !history) return 0;
        return 3;
      case `${SETTINGS}/${pathValueSetting}`:
        return 4;
      case SETTINGS:
        return 4;
      case ADD_AUTO_LABEL:
        return 4;
      case ADD_AUTO_LABEL_ECOMMERCE:
        return 4;
      case ADD_AUTO_LABEL_ONM:
        return 4;
      case SOCIAL_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard') return 0;
        return 4;
      case ONLINE_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard') return 0;
        return 4;
      case OFFLINE_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard') return 0;
        return 4;
      case `${SOCIAL_MEDIA_ADD_COMPARISON}/${pathValueComparison}`:
        return 4;
      case CUSTOM_DASHBOARD:
        return 4;
      case `${CUSTOM_DASHBOARD}/${pathValue}`:
        return 4;
      case CUSTOM_REPORT:
        return 4;
      case OVERVIEW:
        return 0;
      case ECOMMERCE_COMPARISON:
        if (tabComparison === 'dashboard') return 0;
        return 4;
      default:
        return 0;
    }
  };

  const menuName = timezone === 7 ? 'Custom Dashboard' : 'Instant Insight';
  const isRetail = customerType === 'b2c';

  const getHeader = () => {
    switch (pathname) {
      case STREAM_PANEL_SOCIAL_MEDIA:
        return <HeaderSocialMediaStreamRetail />;
      case STREAM_PANEL_ONLINE_MEDIA:
        return <HeaderOnlineMediaRetail />;
      case STREAM_PANEL_OFFLINE_MEDIA:
        return <HeaderOfflineMedia />;
      case PEOPLE_PANEL:
        return <HeaderPeoplePanel />;
      case ONLINE_MEDIA_CLIPPING:
        return null;
      case OFFLINE_MEDIA_CLIPPING:
        return <HeaderOnlineMediaClipping />;
      case `${ONLINE_MEDIA_CLIPPING}/${pathValue}`:
        return <HeaderOnlineMediaClippingByIdRetail />;
      case `${OFFLINE_MEDIA_CLIPPING}/${pathValue}`:
        return <HeaderOfflineMediaClippingByIdRetail />;
      case ONLINE_MEDIA_STATISTIC:
        return <HeaderOnlineMediaStatisticRetail />;
      case OFFLINE_MEDIA_STATISTIC:
        return <HeaderOfflineMediaStatistic />;
      case ONLINE_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard') return <HeaderComparisonOnmRetail />;
        return null;
      case OFFLINE_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard')
          return (
            <HeaderOfflineMediaComparison onClick={() => navigator(SETTINGS)} />
          );
        return null;
      case SOCIAL_MEDIA_CAMPAIGN:
        if (!preferences && !history) return <HeaderSocialMediaHashtagRetail />;
        if (preferences) return <HeaderPreferenceCampaign />;
        return (
          <MinimalistHeader
            onClick={() => navigator(SOCIAL_MEDIA_CAMPAIGN)}
            title="Campaign History"
          />
        );
      case SOCIAL_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard')
          return (
            <HeaderComparisonDashboardRetail
              onClickBack={() => navigator(SOCIAL_MEDIA_COMPARISON)}
            />
          );
        return null;
      case SETTINGS:
        return null;
      case `${SETTINGS}/${pathValueSetting}`:
        return null;
      case CUSTOM_DASHBOARD:
        return null;
      case `${CUSTOM_DASHBOARD}/${pathValue}`:
        return <HeaderCustomDashboard />;
      case `${ADD_AUTO_LABEL}`:
        return (
          <MinimalistHeader
            onClick={() => navigator(SETTINGS)}
            title={'Label'}
          />
        );
      case `${ADD_AUTO_LABEL_ECOMMERCE}`:
        return (
          <MinimalistHeader
            onClick={() => navigator(SETTINGS)}
            title={'Auto Label Ecommerce'}
          />
        );
      case `${ADD_AUTO_LABEL_ONM}`:
        return (
          <MinimalistHeader
            onClick={() => navigator(`${SETTINGS_LABEL}?tab=auto_label_onm`)}
            title="Label Article"
          />
        );
      case CUSTOM_REPORT:
        return null;
      case `${CUSTOM_REPORT_NEWSLATTER}`:
        return null;
      case `${CUSTOM_REPORT}/${pathValue}`:
        return <HeaderCustomReportById />;
      case CHAT_NOW_NEW_CHAT:
        return <HeaderChatNowNewChat />;
      case CHAT_NOW_CHAT_HISTORY:
        return (
          <MinimalistHeader
            onClick={() => {}}
            showBackButton={false}
            title="Chat History"
          />
        );
      case CHAT_NOW_GUIDELINES:
        return (
          <MinimalistHeader
            onClick={() => navigator(-1)}
            showBackButton
            title="Guidelines"
          />
        );
      case GOOGLE_REVIEW_COMPARISON:
        if (tabComparison === 'dashboard')
          return (
            <HeaderComparisonDashboard
              onClickBack={() => navigator(GOOGLE_REVIEW_COMPARISON)}
            />
          );
        return (
          <MinimalistHeader
            onClick={() => navigator(GOOGLE_REVIEW_COMPARISON)}
            title={pathValueSetting}
            showBackButton={false}
          />
        );
      case ECOMMERCE_COMPARISON:
        if (tabComparison === 'dashboard')
          return (
            <HeaderComparisonDashboardEcommerce
              onClickBack={() => navigator(ECOMMERCE_COMPARISON)}
            />
          );
        return (
          <MinimalistHeader
            onClick={() => navigator(ECOMMERCE_COMPARISON)}
            title={pathValueSetting}
            showBackButton={false}
          />
        );

      case ECOMMERCE_STREAM:
        return <HeaderEcommerceStream />;

      case OVERVIEW:
        return null;
      case VIDEO_TUTORIAL:
        return (
          <MinimalistHeader
            onClick={() => navigator(-1)}
            showBackButton
            title="Video Tutorial"
          />
        );
      default:
        return <HeaderRetail />;
    }
  };

  //responsive sidebar
  const matchesUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const { useGetUserSubscription } = useBillingSystem();

  const { data: subscriptionData, loading: isLoading } = useGetUserSubscription(
    {
      variables: { projectId: projectId },
      skip: !projectId || customerType === 'b2b'
    }
  );

  const isFreeTrial =
    subscriptionData?.billing_getUserSubscription?.currentUserCycle
      ?.userSubscriptionCycle?.isFreeTrial;
  const freeTrialDuration = moment(
    subscriptionData?.billing_getUserSubscription?.currentUserCycle
      ?.userSubscriptionCycle?.periodEnd
  ).diff(
    subscriptionData?.billing_getUserSubscription?.currentUserCycle
      ?.userSubscriptionCycle?.periodStart,
    'day'
  );

  const webSocketUrl = `wss://ws.dashboard.nolimit.id/?projectId=${projectId}&topic=${process.env.REACT_APP_SOCKET_TOPIC}&token=${process.env.REACT_APP_SOCKET_TOKEN}`;
  const webSocket = useWebSocket(webSocketUrl);
  const objectStatusUpdates = useRef(new Map<string, IObject>());

  useEffect(() => {
    objectStatusUpdates.current.clear();
  }, [projectId]);

  // For listening to object list data status changes
  useEffect(() => {
    if (!webSocket || !projectId) return;

    // Stores latest WebSocket object update by object id as Map.
    const convertUpdatedObjectsToMap = (updatedObjects: IObject[]) => {
      updatedObjects.forEach((object) => {
        objectStatusUpdates.current.set(object.id, object);
      });
    };

    // Applies stored updates to existing objects and appends missing objects from WebSocket.
    const mergeObjectList = (objects: IObject[], updatedObjects: IObject[]) => {
      const objectIds = new Set(objects.map((object) => object.id));
      const missingUpdatedObjects = updatedObjects.filter(
        (object) => !objectIds.has(object.id)
      );

      return [
        ...objects.map((object) => {
          const updatedObject = objectStatusUpdates.current.get(object.id);
          return updatedObject ? { ...object, ...updatedObject } : object;
        }),
        ...missingUpdatedObjects
      ];
    };

    // Writes merged object list back to Apollo cache.
    const writeToObjectListCache = (
      objects: IObject[],
      updatedObjects: IObject[]
    ) => {
      client.writeQuery({
        query: GET_OBJECTS_WITH_STATUS,
        variables: { projectId },
        data: {
          objectManagement_getObjectListWithStatus: mergeObjectList(
            objects,
            updatedObjects
          )
        }
      });
    };

    // Waits for Apollo query result, then reapplies pending WebSocket updates.
    const syncObjectListAfterFetch = (updatedObjects: IObject[]) => {
      client
        .query<{
          objectManagement_getObjectListWithStatus: IObject[];
        }>({
          query: GET_OBJECTS_WITH_STATUS,
          variables: { projectId },
          fetchPolicy: 'cache-first'
        })
        .then(({ data }) => {
          if (!data?.objectManagement_getObjectListWithStatus) return;
          writeToObjectListCache(
            data.objectManagement_getObjectListWithStatus,
            updatedObjects
          );
        })
        .catch(() => {});
    };

    // Updates Apollo cache immediately or retries after cache fetch finishes.
    const syncObjectListCache = (updatedObjects: IObject[]) => {
      try {
        const cachedObjectList = client.readQuery<{
          objectManagement_getObjectListWithStatus: IObject[];
        }>({
          query: GET_OBJECTS_WITH_STATUS,
          variables: { projectId }
        });

        if (!cachedObjectList) {
          syncObjectListAfterFetch(updatedObjects);
          return;
        }

        writeToObjectListCache(
          cachedObjectList.objectManagement_getObjectListWithStatus,
          updatedObjects
        );
      } catch {
        syncObjectListAfterFetch(updatedObjects);
      }
    };

    webSocket.onopen = () => {
      console.log('WebSocket connection established');
    };

    // Handles object status updates from WebSocket payload.
    webSocket.onmessage = (event) => {
      const updatedObjects: IObject[] = JSON.parse(event.data);
      if (!updatedObjects || updatedObjects.length === 0) return;

      convertUpdatedObjectsToMap(updatedObjects);

      const hasSuccessObject = updatedObjects.some(
        (object) => object.status === 'success'
      );
      const isInSettingsPage =
        pathname === SETTINGS_OBJECT || pathname === SETTINGS;

      if (!isInSettingsPage) {
        if (!hasSuccessObject) return;
        handleClickAlert({
          message:
            'Object list has been updated. Click refresh button or refresh the page to see the latest data.',
          severity: 'info'
        });
        return;
      }

      syncObjectListCache(updatedObjects);

      dispatch(
        reducerUpdateObjectList({
          ...objectList,
          data: mergeObjectList(objectList.data, updatedObjects)
        })
      );
    };
  }, [
    client,
    dispatch,
    handleClickAlert,
    objectList,
    pathname,
    projectId,
    webSocket
  ]);

  useEffect(() => {
    getGoogleComparisonList({ variables: { projectId } });
    getEcommerceObjectList({ variables: { projectId } });
    getEcommerceLabel({ variables: { projectId, category: 'ecommerce' } });
  }, [projectId]);

  useEffect(() => {
    if (
      !status ||
      isProviderLtd ||
      customerType === 'b2b' ||
      !subscriptionEndDate
    )
      return;

    if (isFreeTrial) {
      handleShowTopNotification({
        message: `You’re currently on a ${freeTrialDuration}-day free trial. Upgrade your subscription to monitor more brands, get higher quotas, and enjoy longer access. Manage your billing`,
        severity: 'info',
        showCloseButton: true
      });
    }

    if (status === 'active') return;

    const terminatedDate = new Date(subscriptionEndDate);
    terminatedDate.setDate(terminatedDate.getDate() + 14);

    if (status === 'almost_on_hold') {
      const remainingDays = Math.round(
        (subscriptionEndDate.getTime() - new Date().getTime()) /
          (1000 * 3600 * 24)
      );
      handleShowTopNotification({
        message: `Your next billing is due in ${remainingDays} ${
          remainingDays > 1 ? 'days' : 'day'
        } - `,
        severity: 'warning',
        showCloseButton: true
      });
    } else if (status === 'on_hold') {
      handleShowTopNotification({
        message:
          'You’re on a grace period! Your subscription data are on hold - ',
        severity: 'error',
        showCloseButton: false
      });
    } else if (status === 'almost_terminated') {
      const remainingDays = Math.round(
        (new Date().getTime() - terminatedDate.getTime()) / (1000 * 3600 * 24)
      );
      handleShowTopNotification({
        message: `Your plan has expired! Your subscription data will not be updated in the next ${remainingDays} ${
          remainingDays > 1 ? 'days' : 'day'
        } - `,
        severity: 'error',
        showCloseButton: false
      });
    } else if (status === 'terminated') {
      handleShowTopNotification({
        message: 'Your plan has expired. Please ',
        severity: 'error',
        showCloseButton: false
      });
    } else {
      handleCloseNotification();
    }
  }, [
    status,
    subscriptionEndDate,
    customerType,
    isFreeTrial,
    freeTrialDuration
  ]);

  const matchedMediaUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const [openAnounce, setOpenAnounce] = useState(false);

  useEffect(() => {
    const isDesktopOnlyPage =
      pathname.includes(SOCIAL_MEDIA_SNA) ||
      pathname.includes(SOCIAL_MEDIA_DNA) ||
      pathname.includes(SOCIAL_MEDIA_CLUSTERING) ||
      pathname.includes(CUSTOM_REPORT);

    setOpenAnounce(!matchedMediaUpMd && isDesktopOnlyPage);
  }, [matchedMediaUpMd, pathname]);

  const bodyRef = useRef(null);

  useEffect(() => {
    if (isTourButtonOpen) {
      if (bodyRef?.current) {
        bodyRef?.current?.scrollTo({
          top: 0
        });
      }
    }
  }, [isTourButtonOpen]);

  useEffect(() => {
    if (isOnTour) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = 'auto';
    } else {
      document.body.style.overflow = 'auto';
      document.body.style.height = '100%';
    }
  }, [isOnTour]);

  const sidePositionAIAssistant =
    isAIAssistantOpen && positionAIAssistant === 'side';

  return (
    <>
      <ScrollRefProvider>
        {(isTourButtonOpen || isOnTour) && <BlackScreenComponent />}
        {(isTourButtonOpen || isOnTour) && <ModalProductTour />}
        <MainWrapper>
          {matchesUpMd && <Sidebar />}
          <MainContent isOnTour={isOnTour}>
            {isRetail ? <TopNotification /> : null}
            <TopHeaderV2 />
            <ErrorBoundary
              FallbackComponent={() => <></>}
              onError={(error: Error, info) => {
                handleClickAlert({
                  horizontal: 'center',
                  vertical: 'top',
                  message: 'Something went wrong',
                  severity: 'error'
                });
                console.log(error, info.componentStack);
              }}
            >
              <MainBody isOnTour={isOnTour} isRetail={isRetail} ref={bodyRef}>
                {getHeader()}
                <Box
                  sx={{
                    px: 4,
                    pt: getTopPadding(),
                    pb: 4,
                    background: '#F5F5F5'
                  }}
                >
                  <Outlet />
                </Box>
              </MainBody>
            </ErrorBoundary>
          </MainContent>
          {sidePositionAIAssistant && (
            <ChatNowRetail
              mode="normal"
              customWidthPercentage={matchesUpMd ? '37%' : undefined}
            />
          )}
        </MainWrapper>
        <Snackbar
          anchorOrigin={{
            vertical: stateAlert.vertical,
            horizontal: stateAlert.horizontal
          }}
          open={stateAlert.open}
          onClose={handleCloseAlert}
          autoHideDuration={10000}
        >
          <Alert
            onClose={handleCloseAlert}
            severity={stateAlert.severity}
            sx={{ width: '100%' }}
          >
            {stateAlert.message}
            {stateAlert.action}
          </Alert>
        </Snackbar>
        <FloatingButtons />
        {isPictureInPictureMode && (
          <ChatNowRetail mode="pip" isVisible={isPictureInPictureMode} />
        )}
        <UnSupportPage
          open={openAnounce}
          onClose={() => {
            setOpenAnounce(false);
            navigator('/');
          }}
        />
      </ScrollRefProvider>
    </>
  );
};

export default SidebarLayout;
